<script>
    export let item;
    export let clickItem;
    export let sourceName;
    export let filteredItems;

    $: checked = !!(filteredItems[sourceName]?.find(_item => _item.id === item.id))
</script>

<div style="padding-bottom:8px;display:flex;">
    <input
        style="margin:0;"
        type="checkbox"
        value={item.id}
        id="source-item-{item.id}"
        on:change={(e) => clickItem(e.target.checked, sourceName, item)}
        checked={checked}
    />
    <label for="source-item-{item.id}" style="color:rgb(0,100,200);padding-left:8px;">{item.title}</label>
</div>